const navLinks = {
    links :[
    {
        id: 1,
        title: 'Weather',
        icon : '',
        component: 'Homescreen',
        route: ''
    },
    // {
    //     id: 2,
    //     title: 'News',
    //     icon: '',
    //     component: 'News',
    //     route: 'news'
    // }
],
    system: [
        {
            id: 1,
            title: 'Settings',
            icon: '',
            component: 'Settings',
            route: 'settings'
        },
        {
            id: 2,
            title: 'Logout',
            icon: '',
            component: '',
            route: ''
        }
    ],
    login: {
            id: 1,
            title: 'Login',
            icon: '',
            component: 'Login',
            route: 'login'
        }
    
}

export {navLinks};